// extracted by mini-css-extract-plugin
export default {"tabs":"FaultLevelTabs_tabs__LME7o"};